import React from "react";
import {useNavigate} from "react-router-dom";



export default function ContactText() {
	let navigate = useNavigate();
    return (
        <>
		<div className='container2' style={{ paddingTop:'5%', width:'98%', height:'20%',  justifyContent:'space-evenly', alignItems:'self-start'}}>
			<img style={{ width: '15%'}} src={"./images/profile.jpg"} alt="" />
            
            <div style={ {width: '80%'}}>
            <h1 className='text'>
            <span style={ {width: '100%'} }>
            Architecture | Virtual Production | Photography
               
            </span>        
			</h1>

            <h1 className='text3' style={ {width: '100%', paddingLeft:'2%', paddingTop:'4%'} }>
         
            <span style={{ paddingTop:'4%' }}>
                contact:   
            </span> 
            <span >
                jo.belz@icloud.com
            </span> 
            <span >
                +49 160 6911911
            </span> 
			</h1>


            </div>

            
        </div>

        <div className='container2' style={{ paddingTop:'10%', width:'97%',  justifyContent:'start', alignItems:'self-start'}}>
            <h1 className='text' style={{ color: 0xffffff }}>
            <span onClick={() => {navigate('/');}} style={{ marginTop:150, marginLeft: 10 }}>
                 back 
            </span>
            </h1>
        </div>
        </>
	);
}
